<template>
    <div class="content-dash">
        <div class="content-dash-cards">
            <div v-if="stats">
                <div class="card-dash">
                    <div class="row">
                        <h3>Solicitações Aguardando</h3>
                        <h2>{{ Funcoes.formatInteger(stats.ttsolicitacoes) }}</h2>
                    </div>
                </div>

                <div class="card-dash">
                    <div class="row">
                        <h3>Total Ordens de Serviço</h3>
                        <h2>{{ Funcoes.formatInteger(stats.ttos) }}</h2>
                    </div>
                </div>

                <div class="card-dash">
                    <div class="row">
                        <h3>Ordens de Serviço Aguardando</h3>
                        <h2>{{ Funcoes.formatInteger(stats.ttosaguardando) }}</h2>
                    </div>
                </div>

                <div class="card-dash">
                    <div class="row">
                        <h3>Ordens de Serviço Atendidas</h3>
                        <h2>{{ Funcoes.formatInteger(stats.ttosatendida) }}</h2>
                    </div>
                </div>
            </div>
        </div>
        

        <div class="content-dash-chart">
            <ObrasMainChart :data="chartData" />
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericPost } from '@/funcoes/api';
import { globalStore } from '@/globals';
import ObrasMainChart from '@/components/charts/ObrasMainChart.vue';


const stats = ref({
    ttos: 0,
    ttosaguardando: 0,
    ttosatendida:0,
});
const chartData = ref([]);

const loadStats = async () => {
    try{
        const response = await genericPost('/dashboard/obras/resumo', {idmunicipio: globalStore.idmunicipio});
        stats.value = response[0];
    }catch(error){console.error('Erro ao carregar dados de estatísticas:', error);}
};

const loadChartData = async () => {
    const now = new Date();
    let inicio, fim;
    try{
        inicio = new Date(now.getFullYear(), now.getMonth() -11, 1);
        fim = new Date(now.getFullYear(), now.getMonth() + 1, 0);

        const response = await genericPost('/dashboard/obras/chamados_mensal', {
            idmunicipio: globalStore.idmunicipio, 
            datainicial: inicio.toISOString().split('T')[0], 
            datafinal: fim.toISOString().split('T')[0]
        });

        const rAtendimentos = await genericPost('/dashboard/obras/atendimentos_mensal', {
            idmunicipio: globalStore.idmunicipio, 
            datainicial: inicio.toISOString().split('T')[0], 
            datafinal: fim.toISOString().split('T')[0]
        });

        chartData.value = [
            response.map(item => ({
                x: `${item.ano}-${String(item.mes).padStart(2, '0')}`,
                y: item.qtdd,})),
            rAtendimentos.map(item => ({
                x: `${item.ano}-${String(item.mes).padStart(2, '0')}`,
                y: item.qtdd,})),
        ];
    }catch (error){console.error('Erro ao carregar dados do gráfico:', error);}
};

onMounted(()=>{
    loadStats();
    loadChartData();
});
</script>


<style scoped>
.card-dash{
    background-color: #ebf2f2;
    padding: 10px;
    border-radius: 8px;
    border: 2px solid #3c5d5d;
    text-align: end;
    margin-bottom: 10px;
}

.content-dash{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
}

.content-dash-cards{
    width: 350px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.content-dash-chart{
    flex-grow: 1;
    min-width: 500px;
    display: flex;
    justify-content: center; /* Centraliza o gráfico na área */
    align-items: center;
}
</style>